import { render } from "./AdminResetPassword.vue?vue&type=template&id=48271140"
import script from "./AdminResetPassword.vue?vue&type=script&lang=js"
export * from "./AdminResetPassword.vue?vue&type=script&lang=js"

import "./AdminResetPassword.vue?vue&type=style&index=0&id=48271140&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__